export default __webpack_public_path__ + "static/media/NASA_Wormball_logo.2169bb9f.svg";